import {BridgeType, resolveBridgeType, ResponseType} from './BridgeApi';
import accountLinkingLauncher from './launcher/accountLinking.launcher';
import accountLinkingMock from './mock/accountLinking.mock';
import accountLinkingWeb from './web/accountLinking.web';

export interface LinkResponse {
    serviceprovider: string;
    authtoken: string;
    errordescription: string;
}

export type AccountLinkingResponseCallback = (
    linkResponse: LinkResponse,
    responseType: ResponseType
) => void;

export interface AccountLinkingBridge {
    linkAccount(accountType: string): Promise<void>;
    registerResponseCallback(callback: AccountLinkingResponseCallback): Promise<void>;
}

const bridges = {
    [BridgeType.LAUNCHER]: accountLinkingLauncher,
    [BridgeType.WEB]: accountLinkingWeb,
    [BridgeType.MOCK]: accountLinkingMock
};

export default (): AccountLinkingBridge => bridges[resolveBridgeType()];
